// Alert Bridge - 컴포넌트 외부에서 Alert 시스템 사용을 위한 브릿지
type AlertListener = (
  type: 'success' | 'error' | 'warning' | 'info',
  message: string,
  title?: string
) => void

class AlertBridge {
  private listeners: AlertListener[] = []

  subscribe(listener: AlertListener) {
    this.listeners.push(listener)
    return () => {
      this.listeners = this.listeners.filter((l) => l !== listener)
    }
  }

  emit(
    type: 'success' | 'error' | 'warning' | 'info',
    message: string,
    title?: string
  ) {
    this.listeners.forEach((listener) => listener(type, message, title))
  }
}

export const alertBridge = new AlertBridge()
